<template>
    <nav class="header-nav-container">
        <button class="burger-button" :class="{ active: showMobileMenu }"
                @click="showMobileMenu = !showMobileMenu"></button>
        <div :class="{ active: showMobileMenu }" class="menu-container">
            <div class="header-row1">
                <LocalisationSwitcher ref="localisation"></LocalisationSwitcher>
<!--                <div :class=" {'sub-nav-search ' : isNavMenuOpen}" class="header-search-container">-->
                    <!--                    <SearchBar></SearchBar>-->
                    <LanguageSwitcher class="hide-small"></LanguageSwitcher>
<!--                </div>-->
            </div>
            <div class="header-row2">
                <ul class="header-navigation">
                    <NavigationSlots :active-slot="activeSlot" ref="about" currentSlots="about"  @setActiveSlot="setActiveSlot" :global="showMobileMenu">
                        <template #nav-title> {{ $t("message.header.nav_title1") }}</template>
                        <template #button-back>{{ $t("message.header.nav_title1") }}</template>
                        <template #hidden-sub-nav>
                            <a :href="$route('app.story')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/about_image/01.jpg" alt="">
                                    <li>{{ $t("message.navigation.story") }}</li>
                                </div>
                            </a>
                            <a :href="$route('app.areas')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/about_image/02.jpg" alt="">
                                    <li>{{ $t("message.navigation.areas") }}</li>
                                </div>
                            </a>
                            <a :href="$route('app.governance')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/about_image/03.jpg" alt="">
                                    <li>{{ $t("message.navigation.governance") }}</li>
                                </div>
                            </a>
                            <a :href="$route('app.documents')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/about_image/04.jpg" alt="">
                                    <li>{{ $t("message.navigation.relations") }}</li>
                                </div>
                            </a>
                        </template>
                    </NavigationSlots>

                    <NavigationSlots :active-slot="activeSlot" ref="services" currentSlots="services" @setActiveSlot="setActiveSlot" :global="showMobileMenu">
                        <template #nav-title> {{ $t("message.header.nav_title2") }}</template>
                        <template #button-back>{{ $t("message.header.nav_title2") }}</template>
                        <template #hidden-sub-nav>
                            <a :href="$route('app.individual_banking')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/service_image/individual.jpg" alt="">
                                    <li>{{ $t("message.navigation.individual") }}</li>
                                </div>
                            </a>
                            <a :href="$route('app.corporate_banking')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/service_image/corporate.jpg" alt="">
                                    <li>{{ $t("message.navigation.corporate") }}</li>
                                </div>
                            </a>
                            <a :href="$route('app.financial_institutions')">
                                <div class="sub-nav-box sub-nav-box__about_us">
                                    <img src="/images/service_image/financial.jpg" alt="">
                                    <li>{{ $t("message.navigation.financial") }}</li>
                                </div>
                            </a>
<!--                            <span>-->
<!--                                <div class="sub-nav-box sub-nav-box__about_us">-->
<!--                                    <img src="/images/service_image/wealth.jpg" alt="">-->
<!--                                    <li>{{ $t("message.navigation.management_solutions") }} <span class="coming-soon-tip">comingsoon</span></li>-->
<!--                                </div>-->
<!--                            </span>-->
                        </template>

                    </NavigationSlots>

                    <!--<NavigationSlots>-->
                    <!--    <template #nav-title>-->

                    <!--            FAQ & Help-->
                    <!--        </a>-->
                    <!--    </template>-->
                    <!--</NavigationSlots>-->

                    <NavigationSlots>
                        <template #nav-title>
                            <a :href="$route('app.contact')">
                                {{ $t("message.header.nav_title3") }}
                            </a>
                        </template>
                    </NavigationSlots>

                    <!--                    <li>-->
                    <!--                        <HeaderDevNav></HeaderDevNav>-->
                    <!--                    </li>-->
                    <li>
                        <LanguageSwitcher class="hide-desktop"></LanguageSwitcher>
                    </li>

                </ul>
                <div class="login-container">
                    <!--<button class="button-primary-no-svg">Login</button>-->
                    <a class="button-primary" :href="$route('app.contact')" >{{ $t("message.buttons.contact") }}
                        <!--<svg class="hide-desktop" width="18" height="14" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M10.293.293a1 1 0 0 1 1.414 0l6 6A1.006 1.006 0 0 1 18 7l-.004-.085c.002.017.003.034.003.052L18 7a1.018 1.018 0 0 1-.146.52 1.035 1.035 0 0 1-.147.187l.08-.09a1.003 1.003 0 0 1-.007.008l-.073.082-6 6a1 1 0 0 1-1.414-1.414l4.292-4.294L1 8a1 1 0 0 1-.993-.883L0 7a1 1 0 0 1 1-1l13.585-.001-4.292-4.292a1 1 0 0 1-.083-1.32Z" id="a"/></defs><use fill="#FFF" fill-rule="nonzero" xlink:href="#a"/></svg>-->
                    </a>
                </div>
            </div>
            <UnderNav></UnderNav>
        </div>
    </nav>
</template>

<script>
import LanguageSwitcher from "../../Layout/LanguageSwitcher";
import HeaderDevNav from "./HeaderDevNav";
import LocalisationSwitcher from "./LocalisationSwitcher";
import SearchBar from "../common/SearchBar";
import NavigationSlots from "../common/NavigationSlots";
import UnderNav from "./UnderNav";

export default {
    components: {UnderNav, NavigationSlots, SearchBar, LocalisationSwitcher, HeaderDevNav, LanguageSwitcher},
    data() {
        return {
            showMobileMenu: false,
            isNavMenuOpen: false,
            activeSlot:null,
        }
    },
    watch: {
        showMobileMenu(newValue, oldValue) {
            if(newValue == false){
                this.$refs.services.isOpen = false
                this.$refs.about.isOpen = false
                this.$refs.localisation.displayMenuSwitcher = false

            }
        }
    },
    methods: {
        addTransitionDelay(elem) {
            for (const [index, value] of elem.entries()) {
                value.style.transitionDelay = "0." + (index + 1) + "s"
            }
        },
        changePage(route, data = {}, options = {}) {
            this.$inertia.get(route, data, {
                onStart: () => {
                    this.showMobileMenu = false;
                    // this.$refs.services.isOpen = false
                    // this.$refs.about.isOpen = false
                    this.setActiveSlot(null)

                },
                ...options,
            })
        },
        setActiveSlot(activeSlot) {
            this.activeSlot = activeSlot;

        }
    },
    mounted() {
        // const intervalID = setInterval(() => {
        //     this.test()
        // }, 2000,);
        let about_us_boxes = document.querySelectorAll(".sub-nav-box__about_us")
        let our_services_boxes = document.querySelectorAll(".sub-nav-box__our_services")
        this.addTransitionDelay(about_us_boxes)
        this.addTransitionDelay(our_services_boxes)
    }

}
</script>

<style scoped>

</style>
